import { mapHttpErrorToResourceError } from '../../resources/core/errors';
import { fixPythonDates } from './fix-python-dates.util';

type PythonErrorBody = {
	httpError?: string;
	message?: string;
	status?: string;
};

export async function parsePythonResponse<T>(response: Response): Promise<T> {
	let json: PythonErrorBody & Record<string, unknown>;

	try {
		json = ((await response.json()) ?? {}) as PythonErrorBody & Record<string, unknown>;
	} catch {
		json = {};
	}

	const isUnauthorized =
		response.status === 401 || json.status === '401 Unauthorized' || json.message === 'You are not authenticated.';

	if (isUnauthorized) {
		const message = (json.message as string) || 'You are not authenticated.';
		throw mapHttpErrorToResourceError({
			name: 'Unauthorized',
			message,
			status: 401,
			opt: { message },
		});
	}

	if (json.httpError) {
		const message = json.message || json.httpError;
		throw mapHttpErrorToResourceError({
			name: 'PythonHTTPError',
			message,
			status: response.status,
			opt: { message },
		});
	}

	return fixPythonDates(json) as T;
}
